import context from '../context'
import getComponentKey from '@/utils/getComponentKey'

const initialState = {
  componentKey: getComponentKey()
}

const actionTypes = {
  Updated: 'temporaryFileAttachments/updated'
}

const actionCreators = {
  updateVerifiedStatus: (input) => (dispatch, getState) => {
    // eslint-disable-next-line promise/catch-or-return
    context.api.temporaryFileService.updateVerifiedStatus(input)
      .then(response => {
        dispatch({ type: actionTypes.Updated })
      })
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.Updated: return { ...state, componentKey: getComponentKey() }
    default: return state
  }
}

export { actionCreators, reducer }



// WEBPACK FOOTER //
// ./src/store/TemporaryFileAttachment.js